<template>
  <div class="form-body">
    <div class="row">
      <div>
        <div class="form">
          <div class="form-items" style="margin-top: 5%;">
              <div class="container">
                <b-form
                  class="register-form"
                  v-on:submit.prevent="onSubmitProfile"
                  novalidate
                  style="background-color: #ffffff;padding: 20px;"
                >
                  <div>
                    <div>
                      <h1
                        class="float-left mb-0 ml-3"
                        style="all:unset; font-size:25px"
                      >
                        HI {{ form.firstName }}
                      </h1>
                    </div>
                    <br />
                    <div class="skip">
                      <h3 class="float-left mb-0 ml-3 titleheader">Resume & Video Upload</h3>
                        <div>
                  <button @click="skipToNext()"  class="btn skipbtn" style="background: #5bad2b; color:white">
                    SKIP NOW <i class="fa fa-forward" aria-hidden="true"></i></button
                  >
                      </div>
                    </div>
                    <hr />
                    <div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Attachment</label>
                          <div class="custom-file-upload">
                            <div v-if="files.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="files.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in files.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removeUploading(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="file"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="fileUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="file"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                            Supported format (.pdf, .doc, .docx), Size (Max 2MB)
                          </p>
                          <span v-if="fileErrorShow" class="error-msg">* Please select the file</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-row skills">
                      <div class="UserUpload">
                        <div class="form-group">
                          <label>Video Attachment</label>
                          <div class="custom-file-upload">
                            <div v-if="video.length < 1" class="show-doc-empty">
                              Select the File
                            </div>
                            <div class="show-doc" v-if="video.length > 0">
                              <span
                                class="doc-file pull-left"
                                v-for="x in video.slice(0, 2)"
                                :key="x"
                                ><span class="doc-name">{{ x.name }} </span
                                ><i
                                  @click="removeVideo(x)"
                                  class="fa fa-times"
                                  style="color: #ccc;"
                                  aria-hidden="true"
                                ></i
                              ></span>
                            </div>
                            <label for="video"
                              ><i class="uil uil-upload" aria-hidden="true"></i> Upload
                            </label>
                            <input
                              @change="videoUpload($event)"
                              style="visibility: hidden;"
                              type="file"
                              id="video"
                              accept="video/*"
                              name="myfiles[]"
                              multiple
                            />
                          </div>
                          <p style="color: #aeaaaa;margin: 3px 0 10px;">
                            Supported format (.mp4), Size (Max 10MB)
                          </p>
                          <span v-if="videoErrorShow" class="error-msg">* Please select the video</span>
                          <div><video class="mt-2" id="video-preview" controls style="width: 300px;"></video></div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="form-col">
                      <div class="form-group signupbtn">
                        <button to="/InterviewerExperience" type="button" class="btn btn-success btn-md pull-right addbtn" @click="submitAttachment()"
                        >
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </div>
                </b-form>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'

import { BaseURL } from '../../../shared/classes'
// import Multiselect from 'vue-multiselect'

export default {
  data () {
    return {
      form: {
        firstName: localStorage.getItem('firstName')
      },
      files: [],
      video: [],
      user_id: '',
      signup: '',
      showpreview: false,
      videoErrorShow: false,
      fileErrorShow: false
    }
  },
  created () {
    localStorage.getItem('firstName')
    localStorage.getItem('token')
    localStorage.getItem('_id')
  },
  mounted () {},
  methods: {
    skipToNext () {
      this.user_id = localStorage.getItem('_id')
      this.$router.push('/scheduleAvailability/' + this.user_id)
    },
    videoUpload (e) {
      this.videoErrorShow = false
      console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'video/mp4') {
          if (e.target.files[k].size < '10000001') {
            this.showpreview = true
            this.video.push(e.target.files[k])
            const video = document.getElementById('video-preview')
            const reader = new FileReader()
            reader.readAsDataURL(e.target.files[k])
            reader.addEventListener('load', function () {
              video.src = reader.result
            })
          }
        }
      }
      $('#video').val('')
      console.log(this.video)
    },
    fileUpload (e) {
      this.fileErrorShow = false
      console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (
          e.target.files[k].type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          e.target.files[k].type === 'application/pdf' ||
          e.target.files[k].type === 'application/msword'
        ) {
          if (e.target.files[k].size < '2000001') {
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      console.log(this.files)
    },
    removeUploading (index) {
      this.files.splice(index, 1)
      console.log(this.files)
    },
    removeVideo (index) {
      this.video.splice(index, 1)
      console.log(this.video)
      this.showpreview = false
    },
    uploading () {
      console.log(this.files)
      this.user_id = localStorage.getItem('_id')

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.files.length; k++) {
        formData.append('image', this.files[k])
      }
      if (this.files.length > 0) {
        axios.post(BaseURL + '/profile/upload/certification/' + this.user_id, formData, config)
          .then(response => {
            this.resumeResponse = response.data.message
            this.$awn.success('Resume & Intro Video Uploaded Successfully')
            this.$router.push('/scheduleAvailability/' + this.user_id)
          }, config)
          .catch(e => {
            console.log(e)
          })
      } else {
        this.fileErrorShow = true
      }
    },
    videoUploading () {
      console.log(this.video)
      this.user_id = localStorage.getItem('_id')

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.video.length; k++) {
        formData.append('image', this.video[k])
      }
      if (this.video.length > 0) {
        axios.post(BaseURL + '/profile/upload/video/' + this.user_id, formData, config)
          .then(response => {
            this.videoResponse = response.data.message
          }, config)
          .catch(e => {
            console.log(e)
          })
      } else {
        this.videoErrorShow = true
      }
    },
    submitAttachment () {
      this.uploading()
      this.videoUploading()
      this.$awn.success('Resume & Intro Video Uploaded Successfully')
    }
  }
}
</script>

<style lang="scss" scoped>
.skip{
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  background: #f5f5f5;
}
.register-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.UserUpload {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.signupbtn {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.skills {
  widows: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
   @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
     .skipbtn{
       font-size: 14px;
      //  width: 20%;
       height: 30px;
     }
     .titleheader{
       font-size: 18px;
     }
   }
</style>
